import { compose } from 'ramda'
import { withTheme } from 'modules/util'

import partTheme from './theme.scss'

export default compose(
  withTheme(partTheme)
)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Part/enhancers.js